import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useLocation } from "@reach/router"
import { useStaticQuery, graphql } from "gatsby"

const SEO = ({ title, description, image, canonical }) => {
  const { pathname } = useLocation()
  //const host = window.location.protocol + "//" + window.location.host
  // const host = "https://trs-development.gtsb.io"
  const { site, sanitySiteSettings } = useStaticQuery(query)

  const globalImage =
    sanitySiteSettings.globalShareImage?.asset.gatsbyImageData.images.fallback
      .src

  const {
    defaultTitle,
    titleTemplate,
    defaultDescription,
    twitterUsername,
    siteUrl,
  } = site.siteMetadata

  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    image: image || globalImage,
    url: siteUrl + pathname,
  }

  let canon = []
  if (canonical) {
    canon.push({ rel: "canonical", href: canonical })
  }
  return (
    <Helmet title={seo.title} titleTemplate={titleTemplate}>
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />
      <meta name="theme-color" content="#2C416A" />
      <link rel="canonical" href={seo.url} />
      {seo.url && <meta property="og:url" content={seo.url} />}

      {seo.title && <meta property="og:title" content={seo.title} />}

      {seo.description && (
        <meta property="og:description" content={seo.description} />
      )}

      {seo.image && <meta property="og:image" content={seo.image} />}

      <meta name="twitter:card" content="summary_large_image" />

      {twitterUsername && (
        <meta name="twitter:creator" content={twitterUsername} />
      )}

      {seo.title && <meta name="twitter:title" content={seo.title} />}

      {seo.description && (
        <meta name="twitter:description" content={seo.description} />
      )}

      {seo.image && <meta name="twitter:image" content={seo.image} />}
    </Helmet>
  )
}

export default SEO

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  article: PropTypes.bool,
}

SEO.defaultProps = {
  title: null,
  description: null,
  image: null,
  article: false,
}

const query = graphql`
  query SEO {
    site {
      siteMetadata {
        defaultTitle: title
        titleTemplate
        defaultDescription: description
        twitterUsername: author
        siteUrl: url
      }
    }
    sanitySiteSettings {
      globalShareImage {
        asset {
          gatsbyImageData
        }
      }
    }
  }
`
